import * as stateManagement from '#packages/stateManagement';
import * as coreBi from '#packages/coreBi';
import createNodeProps from './createNodeProps';

import type {
  Dispatch,
  MapDispatchToProps,
  MapStateToProps,
  StateMapperArgs,
} from 'types/redux';
import type { EditorState } from '#packages/stateManagement';
import type { EditorAPI } from '#packages/editorAPI';
import type { NodeProps } from './node';
import type { SectionsLayersPanelOwnProps } from './sectionsLayersPanel';

export interface SectionsLayersPanelStateProps {
  treeProps: {
    section?: NodeProps;
  };
  panelPosition: {
    top: number;
    right: number;
  };
}

const {
  actions: { setHoveredSectionLike },
} = stateManagement.sections;

export const mapStateToProps: MapStateToProps<
  SectionsLayersPanelStateProps,
  SectionsLayersPanelOwnProps
> = ({ editorAPI }, ownProps) => {
  return {
    treeProps: {
      section: createNodeProps(
        editorAPI,
        ownProps.sectionRef,
        { isSOAP: false },
        ownProps.treeNodesContext,
      ),
    },
    panelPosition: ownProps.clickPosition,
  };
};

export interface SectionsLayersPanelDispatchProps {
  openLayersPanel: () => void;
  close: () => void;
  setHoveredSection: () => void;
}

const getEditorAPI = (
  dispatch: Dispatch,
  getState: () => EditorState,
  { editorAPI }: StateMapperArgs,
): EditorAPI => editorAPI;

export const mapDispatchToProps: MapDispatchToProps<
  SectionsLayersPanelDispatchProps,
  SectionsLayersPanelOwnProps
> = (dispatch: Dispatch, ownProps) => {
  const editorAPI: EditorAPI = dispatch(getEditorAPI);
  const { panelName, sectionRef } = ownProps;
  return {
    setHoveredSection: () => {
      return dispatch(setHoveredSectionLike(sectionRef));
    },
    openLayersPanel: () => {
      editorAPI.bi.event(coreBi.events.panels.PANEL_OPENED, {
        panel_name: 'panels.toolPanels.layersPanel',
        origin: panelName,
      });

      editorAPI.panelManager.closePanelByName(panelName);
      editorAPI.selection.selectComponentByCompRef(sectionRef);
      return dispatch(
        stateManagement.layersPanel.actions.showLayersPanel(panelName),
      );
    },
    close: () => editorAPI.panelManager.closePanelByName(panelName),
  };
};
